import { motion } from "framer-motion";
import { Building2 } from "lucide-react";
import { PARTNERS } from "@/lib/content";

export default function PartnersSection() {
  return (
    <section
      data-testid="partners-section"
      className="border-t border-[var(--ri-ink)] bg-white"
    >
      <div className="ri-container py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-10 mb-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4">
              <span className="dot mr-2" /> 06 — Experience & Partners
            </div>
            <h2 className="font-display text-5xl md:text-6xl tracking-tighter leading-[0.95]">
              Trusted across{" "}
              <span className="italic font-display-soft">institutions</span>{" "}
              and industry.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[var(--ri-muted)] leading-relaxed">
              From schools and engineering colleges to incubation cells, university innovation councils and DRDO-grade applications — we bring receipts.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[var(--ri-ink)] border border-[var(--ri-ink)]">
          {PARTNERS.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: i * 0.04 }}
              className="bg-white p-6 md:p-7 group hover:bg-[var(--ri-bg)] transition-colors"
              data-testid={`partner-${i}`}
            >
              <div className="flex flex-col h-full">
                <div className="flex items-start justify-between mb-8">
                  <div className="h-14 w-auto flex items-center">
                    {p.logo ? (
                      <img
                        src={p.logo}
                        alt={p.name}
                        className="h-full w-auto object-contain grayscale group-hover:grayscale-0 transition-all duration-300"
                      />
                    ) : (
                      <Building2
                        size={32}
                        strokeWidth={1.4}
                        className="text-[var(--ri-muted)] group-hover:text-[var(--ri-orange)] transition-colors"
                      />
                    )}
                  </div>
                  <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-[var(--ri-muted)]">
                    0{i + 1}
                  </span>
                </div>
                <div className="mt-auto">
                  <div className="font-display text-xl leading-tight tracking-tight">
                    {p.name}
                  </div>
                  <div className="mt-2 font-mono text-[10px] uppercase tracking-[0.14em] text-[var(--ri-muted)]">
                    {p.note}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
